import { RouteObject } from "react-router-dom";
import { TALENT, TALENT_DETAIL } from "constants/urls";

export default [
  {
    index: true,
    path: TALENT,
    lazy: () => import("modules/talent/pages/Talent"),
  },
  {
    path: TALENT_DETAIL,
    lazy: () => import("modules/talent/pages/TalentDetails"),
  },
] as RouteObject[];
